export default {
  general: [
    {
      url: "/dashboard",
      name: "Dashboard",
      icon: "dashboard",
    },
    {
      url: "/calendar",
      name: "Calender",
      icon: "calendar_today",
    },
    {
      url: "/daily-status",
      name: "Daily Status",
      icon: "assignment",
    },
    {
      url: "/musicCategory",
      name: "Music",
      icon: "music_note",
    },
    {
      url: "/horoscopePage",
      name: "Horoscope",
      icon: "psychology",
    },
    {
      name: "Articles",
      icon: "assignment",
      submenu: [
        {
          url: "/articlecategory",
          name: "Article Category",
        },
        {
          url: "/articles/recent",
          name: "Recent Articles",
        },
      ],
    },
    {
      url: "/festival",
      name: "Festivals",
      icon: "festival",
    },
    {
      url: "/notificationSrv",
      name: "Notifications",
      icon: "notifications",
    },
    {
      name: "Banners",
      icon: "image",
      submenu: [
        {
          url: "/app-banners",
          name: "App Banners",
        },
        {
          url: "/web-banners",
          name: "Web Banners",
        },
        {
          url: "/shop-banners",
          name: "Shop Banners",
        },
      ],
    },
    {
      name: "Events",
      icon: "event",
      submenu: [
        {
          url: "/eventcategory",
          name: "Event Category",
        },
        {
          url: "/events",
          name: "Recent Events",
        },
        {
          url: "/notification",
          name: "Event Notification",
        },
      ],
    },
    {
      url: "/chats",
      name: "Chats",
      icon: "chat",
    },
  ],
  support: [
    {
      url: "/users",
      name: "Users",
      icon: "groups",
    },
    {
      name: "Settings",
      icon: "settings",
      submenu: [{
        url: "/edit-profile",
        name: "Manage Profile",
      },
      {
        url: '/tag',
        name: "Tag Settings",
      },
      {
        url: "/language",
        name: "Language",
      },
      {
        url: "/apps",
        name: "Apps & Reviews",
      },
      {
        url: "/accounts",
        name: "Admin Accounts",
      },
      {
        url: "/settings",
        name: "Global Settings",
      },
      ],
    },
    {
      url: "/more-options",
      name: "More Options",
      icon: "more_horiz",
      submenu: [
        {
          url: "/contest",
          name: "Contest",
        },
        {
          url: "/offer",
          name: "Offer",
        },
        {
          url: "/payments",
          name: "Payments",
        },
        {
          url: "/consult-astrology",
          name: "Consult Astrology",
        },
        {
          url: "/bhakti-promotion",
          name: "Bhakti Promotion",
        },
      ],
    },
    {
      url: "/logout",
      name: "Log Out",
      icon: "logout",
    },
  ],
};
